// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
Vue.use(Vuex)
Vue.config.productionTip = false
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import router from './router'
Vue.use(axios)
import api from './request/apiList.js'
Vue.prototype.$http = api
Vue.prototype.$imgUrl = 'https://yunzhixuanpro.fw366.cn';
import store from './store/index.js'
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)
import Print from 'vue-print-nb'
Vue.use(Print)
import htmlToPdf from '../static/pdf.js'
Vue.use(htmlToPdf)
Vue.prototype.$store = store;
import {
  Message
} from 'element-ui';
Vue.prototype.$message = Message;
import {
  jump
} from "../static/function.js";
Vue.prototype.jump = jump
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next()
})
new Vue({
  el: '#app',
  router,
  components: {
    App,
    store
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js